import { resaleApi } from 'service/api'
import { to } from 'nh-utils'

export const createAlert = props => {
  const payload = { ...props }
  delete payload.whatsapp
  return to(resaleApi.post(`/emgea/alert`, payload))
}
